<template>
  <div>
    <a-button type="primary" @click="add">
      新建活动
    </a-button>
    <a-modal
      title="活动配置"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="700"
    >
      <a-form-model v-bind="layout" :model="ruleForm" :rules="rules" ref="refForm">
        <a-form-model-item  label="活动ID">
          <a-input :disabled='true' placeholder="系统会自动分配的哦" v-model="ruleForm.activityId"/>
        </a-form-model-item>
        <a-form-model-item prop="mainTitle" label="活动名称" has-feedback>
          <a-input v-model="ruleForm.mainTitle"/>
        </a-form-model-item>
        <a-form-model-item prop="activityStartDate" has-feedback label="活动开始日期">
          <a-date-picker
            v-model="ruleForm.activityStartDate"
            show-time
            @openChange="handleStartOpenChange"
            style="width:100%"
            placeholder=""
          />
        </a-form-model-item>
        <a-form-model-item prop="deadline" label="活动截止日期" has-feedback>
          <a-date-picker
            v-model="ruleForm.deadline"
            show-time
            @openChange="handleStartOpenChange"
            style="width:100%"
            placeholder=""
          />
        </a-form-model-item>
        <a-form-model-item prop="max" label="集赞数" has-feedback>
          <a-input placeholder="满足集赞数可获得奖品" v-model="ruleForm.max"/>
        </a-form-model-item>
        <a-form-model-item prop="Prize" label="实物奖品" has-feedback>
          <a-input placeholder='用户成功完成积攒可获得的奖品' v-model="ruleForm.Prize"/>
        </a-form-model-item>
        <a-form-model-item prop="Cycle" label="发放周期（数字）" has-feedback>
          <a-input placeholder='活动结束后X个工作日内安排发奖' v-model="ruleForm.Cycle"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import AV from 'leancloud-storage'
export default {
  name: 'addActivity',
  data () {
    const checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('必填项不能为空'))
      }
      if (isNaN(value)) {
        callback(new Error('请输入数字'))
      } else {
        return callback()
      }
    }
    return {
      visible: false,
      // 数据绑定
      ruleForm: {
        activityld: '',
        mainTitle: '',
        activityStartTime: '',
        deadline: '',
        max: '',
        Prize: '',
        Cycle: ''
      },
      layout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 14 }
      },
      // 验证规则
      rules: {
        mainTitle: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        max: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { validator: checkAge, trigger: 'blur' }
        ],
        activityStartDate: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        deadline: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        Prize: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        Cycle: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { validator: checkAge, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    add () {
      this.visible = true
    },
    handleOk () {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          const newactivityStartDate = this.ruleForm.activityStartDate.format('YYYY-MM-DD HH:mm:ss')
          const newdeadline = this.ruleForm.deadline.format('YYYY-MM-DD HH:mm:ss')
          const Act = AV.Object.extend('ZZCommodity')
          const act = new Act()
          act.set('mainTitle', this.ruleForm.mainTitle)
          act.set('max', this.ruleForm.max)
          act.set('activityStartDate', newactivityStartDate)
          act.set('deadline', newdeadline)
          act.set('Prize', this.ruleForm.Prize)
          act.set('Cycle', this.ruleForm.Cycle)
          act.save().then(res => {
            this.$emit('fatherMethod')
            this.$message.success('新建活动成功')
            this.visible = false
          }, err => {
            console.log(err)
            this.$message.error('新建活动失败')
          })
        } else {
          this.$message.error('请检查配置信息')
          return false
        }
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
